"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _draftExtend = require("draft-extend");

var _constants = require("composer-plugins/lib/constants");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var BLOCK_TYPE = 'atomic';
var DISPLAY_NAME = 'VideoPlugin';
var ENTITY_KEY = _constants.ENTITY_TYPES.video;

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var VideoComponent = options.VideoComponent,
      fileManagerUploadedFileAccess = options.fileManagerUploadedFileAccess,
      getHubLVideoHubLTag = options.getHubLVideoHubLTag,
      _options$videoButtonB = options.videoButtonBuilder,
      videoButtonBuilder = _options$videoButtonB === void 0 ? function () {
    return null;
  } : _options$videoButtonB,
      _options$useUnstyledB = options.useUnstyledButton,
      useUnstyledButton = _options$useUnstyledB === void 0 ? false : _options$useUnstyledB;

  var createEntityOptions = function createEntityOptions(src, name) {
    return [ENTITY_KEY, 'IMMUTABLE', {
      src: src,
      name: name
    }];
  };

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (!(0, _draftHelpers.isCorrectBlockTypeAndSize)(currentBlock, BLOCK_TYPE)) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (entity && entity.getType() === ENTITY_KEY) {
        return {
          component: VideoComponent,
          editable: false,
          props: Object.assign({}, props, {
            fileManagerUploadedFileAccess: fileManagerUploadedFileAccess
          })
        };
      }

      return undefined;
    };
  };

  var htmlToBlock = function htmlToBlock(nodeName, node, lastList, inBlock) {
    if (nodeName === 'figure' && node.firstChild.nodeName === 'VIDEO' || nodeName === 'video' && inBlock !== 'atomic') {
      return BLOCK_TYPE;
    }

    return undefined;
  };

  var htmlToEntity = function htmlToEntity(nodeName, node, createEntity) {
    if (nodeName === 'video') {
      return createEntity.apply(void 0, (0, _toConsumableArray2.default)(createEntityOptions(node.getAttribute('src'), node.getAttribute('alt'))));
    }

    return undefined;
  };

  var entityToHTML = function entityToHTML(entity, originalText) {
    if (entity.type === ENTITY_KEY) {
      var _entity$data = entity.data,
          src = _entity$data.src,
          playerId = _entity$data.playerId;
      var hubLVideoHubLTag = getHubLVideoHubLTag({
        height: 360,
        player_id: playerId,
        width: 640
      });

      if (playerId) {
        return "<div class=\"" + _constants.VIDEO_COMPONENT_CLASSNAME + "\">" + hubLVideoHubLTag + "</div>";
      }

      return "<div class=\"" + _constants.VIDEO_COMPONENT_CLASSNAME + "\"><video width=\"640\" height=\"360\" src=\"" + src + "\" /></div>";
    }

    return originalText;
  };

  var blockToHTML = {
    atomic: {
      start: '<div>',
      end: '</div>'
    }
  };
  return (0, _draftExtend.createPlugin)({
    displayName: DISPLAY_NAME,
    buttons: videoButtonBuilder(useUnstyledButton, fileManagerUploadedFileAccess),
    blockRendererFn: blockRendererFn(options),
    htmlToBlock: htmlToBlock,
    htmlToEntity: htmlToEntity,
    entityToHTML: entityToHTML,
    blockToHTML: blockToHTML
  });
};

exports.default = _default;
module.exports = exports.default;